module.exports = __webpack_public_path__ + "static/media/sheetSteel2.d3d9e43b.jpg";